import e from "stream";
import t from "react";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;

function r(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var n = r(function (t, r) {
  /* @license
  Papa Parse
  v5.2.0
  https://github.com/mholt/PapaParse
  License: MIT
  */
  t.exports = function t() {
    var r = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r ? r : {},
        n = !r.document && !!r.postMessage,
        i = n && /blob:/i.test((r.location || {}).protocol),
        o = {},
        s = 0,
        a = {
      parse: function parse(e, n) {
        var i = (n = n || {}).dynamicTyping || !1;

        if (w(i) && (n.dynamicTypingFunction = i, i = {}), n.dynamicTyping = i, n.transform = !!w(n.transform) && n.transform, n.worker && a.WORKERS_SUPPORTED) {
          var u = function () {
            if (!a.WORKERS_SUPPORTED) return !1;
            var e,
                n,
                i = (e = r.URL || r.webkitURL || null, n = t.toString(), a.BLOB_URL || (a.BLOB_URL = e.createObjectURL(new Blob(["(", n, ")();"], {
              type: "text/javascript"
            })))),
                u = new r.Worker(i);
            return u.onmessage = v, u.id = s++, o[u.id] = u, u;
          }();

          return u.userStep = n.step, u.userChunk = n.chunk, u.userComplete = n.complete, u.userError = n.error, n.step = w(n.step), n.chunk = w(n.chunk), n.complete = w(n.complete), n.error = w(n.error), delete n.worker, void u.postMessage({
            input: e,
            config: n,
            workerId: u.id
          });
        }

        var c = null;
        return e === a.NODE_STREAM_INPUT && "undefined" == typeof PAPA_BROWSER_CONTEXT ? (c = new h(n)).getStream() : ("string" == typeof e ? c = n.download ? new f(n) : new d(n) : !0 === e.readable && w(e.read) && w(e.on) ? c = new p(n) : (r.File && e instanceof File || e instanceof Object) && (c = new l(n)), c.stream(e));
      },
      unparse: function unparse(e, t) {
        var r = !1,
            n = !0,
            i = ",",
            o = "\r\n",
            s = '"',
            u = s + s,
            c = !1,
            f = null;
        !function () {
          if ("object" == typeof t) {
            if ("string" != typeof t.delimiter || a.BAD_DELIMITERS.filter(function (e) {
              return -1 !== t.delimiter.indexOf(e);
            }).length || (i = t.delimiter), ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (r = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (c = t.skipEmptyLines), "string" == typeof t.newline && (o = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (n = t.header), Array.isArray(t.columns)) {
              if (0 === t.columns.length) throw new Error("Option columns is empty");
              f = t.columns;
            }

            void 0 !== t.escapeChar && (u = t.escapeChar + s);
          }
        }();
        var l = new RegExp(m(s), "g");

        if ("string" == typeof e && (e = JSON.parse(e)), Array.isArray(e)) {
          if (!e.length || Array.isArray(e[0])) return p(null, e, c);
          if ("object" == typeof e[0]) return p(f || d(e[0]), e, c);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : d(e.data[0])), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), p(e.fields || [], e.data || [], c);

        throw new Error("Unable to serialize unrecognized input");

        function d(e) {
          if ("object" != typeof e) return [];
          var t = [];

          for (var r in e) {
            t.push(r);
          }

          return t;
        }

        function p(e, t, r) {
          var s = "";
          "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
          var a = Array.isArray(e) && e.length > 0,
              u = !Array.isArray(t[0]);

          if (a && n) {
            for (var c = 0; c < e.length; c++) {
              c > 0 && (s += i), s += h(e[c], c);
            }

            t.length > 0 && (s += o);
          }

          for (var f = 0; f < t.length; f++) {
            var l = a ? e.length : t[f].length,
                d = !1,
                p = a ? 0 === Object.keys(t[f]).length : 0 === t[f].length;

            if (r && !a && (d = "greedy" === r ? "" === t[f].join("").trim() : 1 === t[f].length && 0 === t[f][0].length), "greedy" === r && a) {
              for (var y = [], m = 0; m < l; m++) {
                var g = u ? e[m] : m;
                y.push(t[f][g]);
              }

              d = "" === y.join("").trim();
            }

            if (!d) {
              for (var v = 0; v < l; v++) {
                v > 0 && !p && (s += i);
                var b = a && u ? e[v] : v;
                s += h(t[f][b], v);
              }

              f < t.length - 1 && (!r || l > 0 && !p) && (s += o);
            }
          }

          return s;
        }

        function h(e, t) {
          if (null == e) return "";
          if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
          var n = e.toString().replace(l, u);
          return "boolean" == typeof r && r || "function" == typeof r && r(e, t) || Array.isArray(r) && r[t] || function (e, t) {
            for (var r = 0; r < t.length; r++) {
              if (e.indexOf(t[r]) > -1) return !0;
            }

            return !1;
          }(n, a.BAD_DELIMITERS) || n.indexOf(i) > -1 || " " === n.charAt(0) || " " === n.charAt(n.length - 1) ? s + n + s : n;
        }
      }
    };

    if (a.RECORD_SEP = String.fromCharCode(30), a.UNIT_SEP = String.fromCharCode(31), a.BYTE_ORDER_MARK = "\uFEFF", a.BAD_DELIMITERS = ["\r", "\n", '"', a.BYTE_ORDER_MARK], a.WORKERS_SUPPORTED = !n && !!r.Worker, a.NODE_STREAM_INPUT = 1, a.LocalChunkSize = 10485760, a.RemoteChunkSize = 5242880, a.DefaultDelimiter = ",", a.Parser = g, a.ParserHandle = y, a.NetworkStreamer = f, a.FileStreamer = l, a.StringStreamer = d, a.ReadableStreamStreamer = p, "undefined" == typeof PAPA_BROWSER_CONTEXT && (a.DuplexStreamStreamer = h), r.jQuery) {
      var u = r.jQuery;

      u.fn.parse = function (e) {
        var t = e.config || {},
            n = [];
        return this.each(function (e) {
          if ("INPUT" !== u(this).prop("tagName").toUpperCase() || "file" !== u(this).attr("type").toLowerCase() || !r.FileReader || !this.files || 0 === this.files.length) return !0;

          for (var i = 0; i < this.files.length; i++) {
            n.push({
              file: this.files[i],
              inputElem: this,
              instanceConfig: u.extend({}, t)
            });
          }
        }), i(), this;

        function i() {
          if (0 !== n.length) {
            var t,
                r,
                i,
                s,
                c = n[0];

            if (w(e.before)) {
              var f = e.before(c.file, c.inputElem);

              if ("object" == typeof f) {
                if ("abort" === f.action) return t = "AbortError", r = c.file, i = c.inputElem, s = f.reason, void (w(e.error) && e.error({
                  name: t
                }, r, i, s));
                if ("skip" === f.action) return void o();
                "object" == typeof f.config && (c.instanceConfig = u.extend(c.instanceConfig, f.config));
              } else if ("skip" === f) return void o();
            }

            var l = c.instanceConfig.complete;
            c.instanceConfig.complete = function (e) {
              w(l) && l(e, c.file, c.inputElem), o();
            }, a.parse(c.file, c.instanceConfig);
          } else w(e.complete) && e.complete();
        }

        function o() {
          n.splice(0, 1), i();
        }
      };
    }

    function c(e) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
        data: [],
        errors: [],
        meta: {}
      }, function (e) {
        var t = S(e);
        t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null), this._handle = new y(t), this._handle.streamer = this, this._config = t;
      }.call(this, e), this.parseChunk = function (e, t) {
        if (this.isFirstChunk && w(this._config.beforeFirstChunk)) {
          var n = this._config.beforeFirstChunk(e);

          void 0 !== n && (e = n);
        }

        this.isFirstChunk = !1, this._halted = !1;
        var o = this._partialLine + e;
        this._partialLine = "";

        var s = this._handle.parse(o, this._baseIndex, !this._finished);

        if (!this._handle.paused() && !this._handle.aborted()) {
          var u = s.meta.cursor;
          this._finished || (this._partialLine = o.substring(u - this._baseIndex), this._baseIndex = u), s && s.data && (this._rowCount += s.data.length);
          var c = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (i) r.postMessage({
            results: s,
            workerId: a.WORKER_ID,
            finished: c
          });else if (w(this._config.chunk) && !t) {
            if (this._config.chunk(s, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            s = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(s.data), this._completeResults.errors = this._completeResults.errors.concat(s.errors), this._completeResults.meta = s.meta), this._completed || !c || !w(this._config.complete) || s && s.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), c || s && s.meta.paused || this._nextChunk(), s;
        }

        this._halted = !0;
      }, this._sendError = function (e) {
        w(this._config.error) ? this._config.error(e) : i && this._config.error && r.postMessage({
          workerId: a.WORKER_ID,
          error: e,
          finished: !1
        });
      };
    }

    function f(e) {
      var t;
      (e = e || {}).chunkSize || (e.chunkSize = a.RemoteChunkSize), c.call(this, e), this._nextChunk = n ? function () {
        this._readChunk(), this._chunkLoaded();
      } : function () {
        this._readChunk();
      }, this.stream = function (e) {
        this._input = e, this._nextChunk();
      }, this._readChunk = function () {
        if (this._finished) this._chunkLoaded();else {
          if (t = new XMLHttpRequest(), this._config.withCredentials && (t.withCredentials = this._config.withCredentials), n || (t.onload = E(this._chunkLoaded, this), t.onerror = E(this._chunkError, this)), t.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
            var e = this._config.downloadRequestHeaders;

            for (var r in e) {
              t.setRequestHeader(r, e[r]);
            }
          }

          if (this._config.chunkSize) {
            var i = this._start + this._config.chunkSize - 1;
            t.setRequestHeader("Range", "bytes=" + this._start + "-" + i);
          }

          try {
            t.send(this._config.downloadRequestBody);
          } catch (e) {
            this._chunkError(e.message);
          }

          n && 0 === t.status && this._chunkError();
        }
      }, this._chunkLoaded = function () {
        4 === t.readyState && (t.status < 200 || t.status >= 400 ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : t.responseText.length, this._finished = !this._config.chunkSize || this._start >= function (e) {
          var t = e.getResponseHeader("Content-Range");
          return null === t ? -1 : parseInt(t.substring(t.lastIndexOf("/") + 1));
        }(t), this.parseChunk(t.responseText)));
      }, this._chunkError = function (e) {
        var r = t.statusText || e;

        this._sendError(new Error(r));
      };
    }

    function l(e) {
      var t, r;
      (e = e || {}).chunkSize || (e.chunkSize = a.LocalChunkSize), c.call(this, e);
      var n = "undefined" != typeof FileReader;
      this.stream = function (e) {
        this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((t = new FileReader()).onload = E(this._chunkLoaded, this), t.onerror = E(this._chunkError, this)) : t = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function () {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function () {
        var e = this._input;

        if (this._config.chunkSize) {
          var i = Math.min(this._start + this._config.chunkSize, this._input.size);
          e = r.call(e, this._start, i);
        }

        var o = t.readAsText(e, this._config.encoding);
        n || this._chunkLoaded({
          target: {
            result: o
          }
        });
      }, this._chunkLoaded = function (e) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
      }, this._chunkError = function () {
        this._sendError(t.error);
      };
    }

    function d(e) {
      var t;
      e = e || {}, c.call(this, e), this.stream = function (e) {
        return t = e, this._nextChunk();
      }, this._nextChunk = function () {
        if (!this._finished) {
          var e,
              r = this._config.chunkSize;
          return r ? (e = t.substring(0, r), t = t.substring(r)) : (e = t, t = ""), this._finished = !t, this.parseChunk(e);
        }
      };
    }

    function p(e) {
      e = e || {}, c.call(this, e);
      var t = [],
          r = !0,
          n = !1;
      this.pause = function () {
        c.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function () {
        c.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function (e) {
        this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function () {
        n && 1 === t.length && (this._finished = !0);
      }, this._nextChunk = function () {
        this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
      }, this._streamData = E(function (e) {
        try {
          t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
        } catch (e) {
          this._streamError(e);
        }
      }, this), this._streamError = E(function (e) {
        this._streamCleanUp(), this._sendError(e);
      }, this), this._streamEnd = E(function () {
        this._streamCleanUp(), n = !0, this._streamData("");
      }, this), this._streamCleanUp = E(function () {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }

    function h(t) {
      var r = e.Duplex,
          n = S(t),
          i = !0,
          o = !1,
          s = [],
          a = null;
      this._onCsvData = function (e) {
        var t = e.data;
        a.push(t) || this._handle.paused() || this._handle.pause();
      }, this._onCsvComplete = function () {
        a.push(null);
      }, n.step = E(this._onCsvData, this), n.complete = E(this._onCsvComplete, this), c.call(this, n), this._nextChunk = function () {
        o && 1 === s.length && (this._finished = !0), s.length ? s.shift()() : i = !0;
      }, this._addToParseQueue = function (e, t) {
        s.push(E(function () {
          if (this.parseChunk("string" == typeof e ? e : e.toString(n.encoding)), w(t)) return t();
        }, this)), i && (i = !1, this._nextChunk());
      }, this._onRead = function () {
        this._handle.paused() && this._handle.resume();
      }, this._onWrite = function (e, t, r) {
        this._addToParseQueue(e, r);
      }, this._onWriteComplete = function () {
        o = !0, this._addToParseQueue("");
      }, this.getStream = function () {
        return a;
      }, (a = new r({
        readableObjectMode: !0,
        decodeStrings: !1,
        read: E(this._onRead, this),
        write: E(this._onWrite, this)
      })).once("finish", E(this._onWriteComplete, this));
    }

    function y(e) {
      var t,
          r,
          n,
          i = Math.pow(2, 53),
          o = -i,
          s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)(e[-+]?\d+)?\s*$/,
          u = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
          c = this,
          f = 0,
          l = 0,
          d = !1,
          p = !1,
          h = [],
          y = {
        data: [],
        errors: [],
        meta: {}
      };

      if (w(e.step)) {
        var v = e.step;

        e.step = function (t) {
          if (y = t, E()) _();else {
            if (_(), 0 === y.data.length) return;
            f += t.data.length, e.preview && f > e.preview ? r.abort() : (y.data = y.data[0], v(y, c));
          }
        };
      }

      function b(t) {
        return "greedy" === e.skipEmptyLines ? "" === t.join("").trim() : 1 === t.length && 0 === t[0].length;
      }

      function _() {
        if (y && n && (C("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + a.DefaultDelimiter + "'"), n = !1), e.skipEmptyLines) for (var t = 0; t < y.data.length; t++) {
          b(y.data[t]) && y.data.splice(t--, 1);
        }
        return E() && function () {
          if (y) if (Array.isArray(y.data[0])) {
            for (var t = 0; E() && t < y.data.length; t++) {
              y.data[t].forEach(r);
            }

            y.data.splice(0, 1);
          } else y.data.forEach(r);

          function r(t) {
            w(e.transformHeader) && (t = e.transformHeader(t)), h.push(t);
          }
        }(), function () {
          if (!y || !e.header && !e.dynamicTyping && !e.transform) return y;

          function t(t, r) {
            var n,
                i = e.header ? {} : [];

            for (n = 0; n < t.length; n++) {
              var o = n,
                  s = t[n];
              e.header && (o = n >= h.length ? "__parsed_extra" : h[n]), e.transform && (s = e.transform(s, o)), s = O(o, s), "__parsed_extra" === o ? (i[o] = i[o] || [], i[o].push(s)) : i[o] = s;
            }

            return e.header && (n > h.length ? C("FieldMismatch", "TooManyFields", "Too many fields: expected " + h.length + " fields but parsed " + n, l + r) : n < h.length && C("FieldMismatch", "TooFewFields", "Too few fields: expected " + h.length + " fields but parsed " + n, l + r)), i;
          }

          var r = 1;
          return !y.data.length || Array.isArray(y.data[0]) ? (y.data = y.data.map(t), r = y.data.length) : y.data = t(y.data, 0), e.header && y.meta && (y.meta.fields = h), l += r, y;
        }();
      }

      function E() {
        return e.header && 0 === h.length;
      }

      function O(t, r) {
        return function (t) {
          return e.dynamicTypingFunction && void 0 === e.dynamicTyping[t] && (e.dynamicTyping[t] = e.dynamicTypingFunction(t)), !0 === (e.dynamicTyping[t] || e.dynamicTyping);
        }(t) ? "true" === r || "TRUE" === r || "false" !== r && "FALSE" !== r && (function (e) {
          if (s.test(e)) {
            var t = parseFloat(e);
            if (t > o && t < i) return !0;
          }

          return !1;
        }(r) ? parseFloat(r) : u.test(r) ? new Date(r) : "" === r ? null : r) : r;
      }

      function C(e, t, r, n) {
        var i = {
          type: e,
          code: t,
          message: r
        };
        void 0 !== n && (i.row = n), y.errors.push(i);
      }

      this.parse = function (i, o, s) {
        var u = e.quoteChar || '"';
        if (e.newline || (e.newline = function (e, t) {
          e = e.substring(0, 1048576);
          var r = new RegExp(m(t) + "([^]*?)" + m(t), "gm"),
              n = (e = e.replace(r, "")).split("\r"),
              i = e.split("\n"),
              o = i.length > 1 && i[0].length < n[0].length;
          if (1 === n.length || o) return "\n";

          for (var s = 0, a = 0; a < n.length; a++) {
            "\n" === n[a][0] && s++;
          }

          return s >= n.length / 2 ? "\r\n" : "\r";
        }(i, u)), n = !1, e.delimiter) w(e.delimiter) && (e.delimiter = e.delimiter(i), y.meta.delimiter = e.delimiter);else {
          var c = function (t, r, n, i, o) {
            var s, u, c, f;
            o = o || [",", "\t", "|", ";", a.RECORD_SEP, a.UNIT_SEP];

            for (var l = 0; l < o.length; l++) {
              var d = o[l],
                  p = 0,
                  h = 0,
                  y = 0;
              c = void 0;

              for (var m = new g({
                comments: i,
                delimiter: d,
                newline: r,
                preview: 10
              }).parse(t), v = 0; v < m.data.length; v++) {
                if (n && b(m.data[v])) y++;else {
                  var _ = m.data[v].length;
                  h += _, void 0 !== c ? _ > 0 && (p += Math.abs(_ - c), c = _) : c = _;
                }
              }

              m.data.length > 0 && (h /= m.data.length - y), (void 0 === u || p <= u) && (void 0 === f || h > f) && h > 1.99 && (u = p, s = d, f = h);
            }

            return e.delimiter = s, {
              successful: !!s,
              bestDelimiter: s
            };
          }(i, e.newline, e.skipEmptyLines, e.comments, e.delimitersToGuess);

          c.successful ? e.delimiter = c.bestDelimiter : (n = !0, e.delimiter = a.DefaultDelimiter), y.meta.delimiter = e.delimiter;
        }
        var f = S(e);
        return e.preview && e.header && f.preview++, t = i, r = new g(f), y = r.parse(t, o, s), _(), d ? {
          meta: {
            paused: !0
          }
        } : y || {
          meta: {
            paused: !1
          }
        };
      }, this.paused = function () {
        return d;
      }, this.pause = function () {
        d = !0, r.abort(), t = w(e.chunk) ? "" : t.substring(r.getCharIndex());
      }, this.resume = function () {
        c.streamer._halted ? (d = !1, c.streamer.parseChunk(t, !0)) : setTimeout(c.resume, 3);
      }, this.aborted = function () {
        return p;
      }, this.abort = function () {
        p = !0, r.abort(), y.meta.aborted = !0, w(e.complete) && e.complete(y), t = "";
      };
    }

    function m(e) {
      return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function g(e) {
      var t,
          r = (e = e || {}).delimiter,
          n = e.newline,
          i = e.comments,
          o = e.step,
          s = e.preview,
          u = e.fastMode,
          c = t = void 0 === e.quoteChar ? '"' : e.quoteChar;
      if (void 0 !== e.escapeChar && (c = e.escapeChar), ("string" != typeof r || a.BAD_DELIMITERS.indexOf(r) > -1) && (r = ","), i === r) throw new Error("Comment character same as delimiter");
      !0 === i ? i = "#" : ("string" != typeof i || a.BAD_DELIMITERS.indexOf(i) > -1) && (i = !1), "\n" !== n && "\r" !== n && "\r\n" !== n && (n = "\n");
      var f = 0,
          l = !1;
      this.parse = function (e, a, d) {
        if ("string" != typeof e) throw new Error("Input must be a string");
        var p = e.length,
            h = r.length,
            y = n.length,
            g = i.length,
            v = w(o);
        f = 0;
        var b = [],
            _ = [],
            S = [],
            E = 0;
        if (!e) return L();

        if (u || !1 !== u && -1 === e.indexOf(t)) {
          for (var O = e.split(n), C = 0; C < O.length; C++) {
            if (S = O[C], f += S.length, C !== O.length - 1) f += n.length;else if (d) return L();

            if (!i || S.substring(0, g) !== i) {
              if (v) {
                if (b = [], A(S.split(r)), N(), l) return L();
              } else A(S.split(r));

              if (s && C >= s) return b = b.slice(0, s), L(!0);
            }
          }

          return L();
        }

        for (var k = e.indexOf(r, f), R = e.indexOf(n, f), x = new RegExp(m(c) + m(t), "g"), T = e.indexOf(t, f);;) {
          if (e[f] !== t) {
            if (i && 0 === S.length && e.substring(f, f + g) === i) {
              if (-1 === R) return L();
              f = R + y, R = e.indexOf(n, f), k = e.indexOf(r, f);
            } else {
              if (-1 !== k && (k < R || -1 === R)) {
                if (!(T > k)) {
                  S.push(e.substring(f, k)), f = k + h, k = e.indexOf(r, f);
                  continue;
                }

                var I = B(k, T, R);

                if (I && void 0 !== I.nextDelim) {
                  k = I.nextDelim, T = I.quoteSearch, S.push(e.substring(f, k)), f = k + h, k = e.indexOf(r, f);
                  continue;
                }
              }

              if (-1 === R) break;
              if (S.push(e.substring(f, R)), M(R + y), v && (N(), l)) return L();
              if (s && b.length >= s) return L(!0);
            }
          } else for (T = f, f++;;) {
            if (-1 === (T = e.indexOf(t, T + 1))) return d || _.push({
              type: "Quotes",
              code: "MissingQuotes",
              message: "Quoted field unterminated",
              row: b.length,
              index: f
            }), F();
            if (T === p - 1) return F(e.substring(f, T).replace(x, t));

            if (t !== c || e[T + 1] !== c) {
              if (t === c || 0 === T || e[T - 1] !== c) {
                -1 !== k && k < T + 1 && (k = e.indexOf(r, T + 1)), -1 !== R && R < T + 1 && (R = e.indexOf(n, T + 1));
                var j = D(-1 === R ? k : Math.min(k, R));

                if (e[T + 1 + j] === r) {
                  S.push(e.substring(f, T).replace(x, t)), f = T + 1 + j + h, e[T + 1 + j + h] !== t && (T = e.indexOf(t, f)), k = e.indexOf(r, f), R = e.indexOf(n, f);
                  break;
                }

                var P = D(R);

                if (e.substring(T + 1 + P, T + 1 + P + y) === n) {
                  if (S.push(e.substring(f, T).replace(x, t)), M(T + 1 + P + y), k = e.indexOf(r, f), T = e.indexOf(t, f), v && (N(), l)) return L();
                  if (s && b.length >= s) return L(!0);
                  break;
                }

                _.push({
                  type: "Quotes",
                  code: "InvalidQuotes",
                  message: "Trailing quote on quoted field is malformed",
                  row: b.length,
                  index: f
                }), T++;
              }
            } else T++;
          }
        }

        return F();

        function A(e) {
          b.push(e), E = f;
        }

        function D(t) {
          var r = 0;

          if (-1 !== t) {
            var n = e.substring(T + 1, t);
            n && "" === n.trim() && (r = n.length);
          }

          return r;
        }

        function F(t) {
          return d || (void 0 === t && (t = e.substring(f)), S.push(t), f = p, A(S), v && N()), L();
        }

        function M(t) {
          f = t, A(S), S = [], R = e.indexOf(n, f);
        }

        function L(e) {
          return {
            data: b,
            errors: _,
            meta: {
              delimiter: r,
              linebreak: n,
              aborted: l,
              truncated: !!e,
              cursor: E + (a || 0)
            }
          };
        }

        function N() {
          o(L()), b = [], _ = [];
        }

        function B(n, i, o) {
          var s = {
            nextDelim: void 0,
            quoteSearch: void 0
          },
              a = e.indexOf(t, i + 1);

          if (n > i && n < a && (a < o || -1 === o)) {
            var u = e.indexOf(r, a);
            if (-1 === u) return s;
            u > a && (a = e.indexOf(t, a + 1)), s = B(u, a, o);
          } else s = {
            nextDelim: n,
            quoteSearch: i
          };

          return s;
        }
      }, this.abort = function () {
        l = !0;
      }, this.getCharIndex = function () {
        return f;
      };
    }

    function v(e) {
      var t = e.data,
          r = o[t.workerId],
          n = !1;
      if (t.error) r.userError(t.error, t.file);else if (t.results && t.results.data) {
        var i = {
          abort: function abort() {
            n = !0, b(t.workerId, {
              data: [],
              errors: [],
              meta: {
                aborted: !0
              }
            });
          },
          pause: _,
          resume: _
        };

        if (w(r.userStep)) {
          for (var s = 0; s < t.results.data.length && (r.userStep({
            data: t.results.data[s],
            errors: t.results.errors,
            meta: t.results.meta
          }, i), !n); s++) {
            ;
          }

          delete t.results;
        } else w(r.userChunk) && (r.userChunk(t.results, i, t.file), delete t.results);
      }
      t.finished && !n && b(t.workerId, t.results);
    }

    function b(e, t) {
      var r = o[e];
      w(r.userComplete) && r.userComplete(t), r.terminate(), delete o[e];
    }

    function _() {
      throw new Error("Not implemented.");
    }

    function S(e) {
      if ("object" != typeof e || null === e) return e;
      var t = Array.isArray(e) ? [] : {};

      for (var r in e) {
        t[r] = S(e[r]);
      }

      return t;
    }

    function E(e, t) {
      return function () {
        e.apply(t, arguments);
      };
    }

    function w(e) {
      return "function" == typeof e;
    }

    return i && (r.onmessage = function (e) {
      var t = e.data;
      if (void 0 === a.WORKER_ID && t && (a.WORKER_ID = t.workerId), "string" == typeof t.input) r.postMessage({
        workerId: a.WORKER_ID,
        results: a.parse(t.input, t.config),
        finished: !0
      });else if (r.File && t.input instanceof File || t.input instanceof Object) {
        var n = a.parse(t.input, t.config);
        n && r.postMessage({
          workerId: a.WORKER_ID,
          results: n,
          finished: !0
        });
      }
    }), f.prototype = Object.create(c.prototype), f.prototype.constructor = f, l.prototype = Object.create(c.prototype), l.prototype.constructor = l, d.prototype = Object.create(d.prototype), d.prototype.constructor = d, p.prototype = Object.create(c.prototype), p.prototype.constructor = p, "undefined" == typeof PAPA_BROWSER_CONTEXT && (h.prototype = Object.create(c.prototype), h.prototype.constructor = h), a;
  }();
});

function i(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function o(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function s(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function a(e) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function u(e, t) {
  return (u = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function c() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function f(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function l(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? f(e) : t;
}

function d(e) {
  return function (e) {
    if (Array.isArray(e)) return p(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return p(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(r);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return p(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  ();
}

function p(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }

  return n;
}

var h = "function" == typeof Symbol && Symbol.for,
    y = h ? Symbol.for("react.element") : 60103,
    m = h ? Symbol.for("react.portal") : 60106,
    g = h ? Symbol.for("react.fragment") : 60107,
    v = h ? Symbol.for("react.strict_mode") : 60108,
    b = h ? Symbol.for("react.profiler") : 60114,
    _ = h ? Symbol.for("react.provider") : 60109,
    S = h ? Symbol.for("react.context") : 60110,
    E = h ? Symbol.for("react.async_mode") : 60111,
    w = h ? Symbol.for("react.concurrent_mode") : 60111,
    O = h ? Symbol.for("react.forward_ref") : 60112,
    C = h ? Symbol.for("react.suspense") : 60113,
    k = h ? Symbol.for("react.suspense_list") : 60120,
    R = h ? Symbol.for("react.memo") : 60115,
    x = h ? Symbol.for("react.lazy") : 60116,
    T = h ? Symbol.for("react.block") : 60121,
    I = h ? Symbol.for("react.fundamental") : 60117,
    j = h ? Symbol.for("react.responder") : 60118,
    P = h ? Symbol.for("react.scope") : 60119;

function A(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case y:
        switch (e = e.type) {
          case E:
          case w:
          case g:
          case b:
          case v:
          case C:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case S:
              case O:
              case x:
              case R:
              case _:
                return e;

              default:
                return t;
            }

        }

      case m:
        return t;
    }
  }
}

function D(e) {
  return A(e) === w;
}

var F = {
  AsyncMode: E,
  ConcurrentMode: w,
  ContextConsumer: S,
  ContextProvider: _,
  Element: y,
  ForwardRef: O,
  Fragment: g,
  Lazy: x,
  Memo: R,
  Portal: m,
  Profiler: b,
  StrictMode: v,
  Suspense: C,
  isAsyncMode: function isAsyncMode(e) {
    return D(e) || A(e) === E;
  },
  isConcurrentMode: D,
  isContextConsumer: function isContextConsumer(e) {
    return A(e) === S;
  },
  isContextProvider: function isContextProvider(e) {
    return A(e) === _;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === y;
  },
  isForwardRef: function isForwardRef(e) {
    return A(e) === O;
  },
  isFragment: function isFragment(e) {
    return A(e) === g;
  },
  isLazy: function isLazy(e) {
    return A(e) === x;
  },
  isMemo: function isMemo(e) {
    return A(e) === R;
  },
  isPortal: function isPortal(e) {
    return A(e) === m;
  },
  isProfiler: function isProfiler(e) {
    return A(e) === b;
  },
  isStrictMode: function isStrictMode(e) {
    return A(e) === v;
  },
  isSuspense: function isSuspense(e) {
    return A(e) === C;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === g || e === w || e === b || e === v || e === C || e === k || "object" == typeof e && null !== e && (e.$$typeof === x || e.$$typeof === R || e.$$typeof === _ || e.$$typeof === S || e.$$typeof === O || e.$$typeof === I || e.$$typeof === j || e.$$typeof === P || e.$$typeof === T);
  },
  typeOf: A
},
    M = r(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        r = e ? Symbol.for("react.element") : 60103,
        n = e ? Symbol.for("react.portal") : 60106,
        i = e ? Symbol.for("react.fragment") : 60107,
        o = e ? Symbol.for("react.strict_mode") : 60108,
        s = e ? Symbol.for("react.profiler") : 60114,
        a = e ? Symbol.for("react.provider") : 60109,
        u = e ? Symbol.for("react.context") : 60110,
        c = e ? Symbol.for("react.async_mode") : 60111,
        f = e ? Symbol.for("react.concurrent_mode") : 60111,
        l = e ? Symbol.for("react.forward_ref") : 60112,
        d = e ? Symbol.for("react.suspense") : 60113,
        p = e ? Symbol.for("react.suspense_list") : 60120,
        h = e ? Symbol.for("react.memo") : 60115,
        y = e ? Symbol.for("react.lazy") : 60116,
        m = e ? Symbol.for("react.block") : 60121,
        g = e ? Symbol.for("react.fundamental") : 60117,
        v = e ? Symbol.for("react.responder") : 60118,
        b = e ? Symbol.for("react.scope") : 60119;

    function _(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case r:
            var p = e.type;

            switch (p) {
              case c:
              case f:
              case i:
              case s:
              case o:
              case d:
                return p;

              default:
                var m = p && p.$$typeof;

                switch (m) {
                  case u:
                  case l:
                  case y:
                  case h:
                  case a:
                    return m;

                  default:
                    return t;
                }

            }

          case n:
            return t;
        }
      }
    }

    var S = c,
        E = f,
        w = u,
        O = a,
        C = r,
        k = l,
        R = i,
        x = y,
        T = h,
        I = n,
        j = s,
        P = o,
        A = d,
        D = !1;

    function F(e) {
      return _(e) === f;
    }

    t.AsyncMode = S, t.ConcurrentMode = E, t.ContextConsumer = w, t.ContextProvider = O, t.Element = C, t.ForwardRef = k, t.Fragment = R, t.Lazy = x, t.Memo = T, t.Portal = I, t.Profiler = j, t.StrictMode = P, t.Suspense = A, t.isAsyncMode = function (e) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(e) || _(e) === c;
    }, t.isConcurrentMode = F, t.isContextConsumer = function (e) {
      return _(e) === u;
    }, t.isContextProvider = function (e) {
      return _(e) === a;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, t.isForwardRef = function (e) {
      return _(e) === l;
    }, t.isFragment = function (e) {
      return _(e) === i;
    }, t.isLazy = function (e) {
      return _(e) === y;
    }, t.isMemo = function (e) {
      return _(e) === h;
    }, t.isPortal = function (e) {
      return _(e) === n;
    }, t.isProfiler = function (e) {
      return _(e) === s;
    }, t.isStrictMode = function (e) {
      return _(e) === o;
    }, t.isSuspense = function (e) {
      return _(e) === d;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === f || e === s || e === o || e === d || e === p || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === h || e.$$typeof === a || e.$$typeof === u || e.$$typeof === l || e.$$typeof === g || e.$$typeof === v || e.$$typeof === b || e.$$typeof === m);
    }, t.typeOf = _;
  }();
}),
    L = (M.AsyncMode, M.ConcurrentMode, M.ContextConsumer, M.ContextProvider, M.Element, M.ForwardRef, M.Fragment, M.Lazy, M.Memo, M.Portal, M.Profiler, M.StrictMode, M.Suspense, M.isAsyncMode, M.isConcurrentMode, M.isContextConsumer, M.isContextProvider, M.isElement, M.isForwardRef, M.isFragment, M.isLazy, M.isMemo, M.isPortal, M.isProfiler, M.isStrictMode, M.isSuspense, M.isValidElementType, M.typeOf, r(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = F : e.exports = M;
})),
    N = Object.getOwnPropertySymbols,
    B = Object.prototype.hasOwnProperty,
    $ = Object.prototype.propertyIsEnumerable;

function z(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var q = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, r = 0; r < 10; r++) {
      t["_" + String.fromCharCode(r)] = r;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      n[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var r, n, i = z(e), o = 1; o < arguments.length; o++) {
    for (var s in r = Object(arguments[o])) {
      B.call(r, s) && (i[s] = r[s]);
    }

    if (N) {
      n = N(r);

      for (var a = 0; a < n.length; a++) {
        $.call(r, n[a]) && (i[n[a]] = r[n[a]]);
      }
    }
  }

  return i;
},
    U = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    W = function W() {};

if ("production" !== process.env.NODE_ENV) {
  var V = U,
      H = {},
      K = Function.call.bind(Object.prototype.hasOwnProperty);

  W = function W(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function Q(e, t, r, n, i) {
  if ("production" !== process.env.NODE_ENV) for (var o in e) {
    if (K(e, o)) {
      var s;

      try {
        if ("function" != typeof e[o]) {
          var a = Error((n || "React class") + ": " + r + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.");
          throw a.name = "Invariant Violation", a;
        }

        s = e[o](t, o, n, r, null, V);
      } catch (e) {
        s = e;
      }

      if (!s || s instanceof Error || W((n || "React class") + ": type specification of " + r + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in H)) {
        H[s.message] = !0;
        var u = i ? i() : "";
        W("Failed " + r + " type: " + s.message + (null != u ? u : ""));
      }
    }
  }
}

Q.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (H = {});
};

var J = Q,
    Y = Function.call.bind(Object.prototype.hasOwnProperty),
    X = function X() {};

function G() {
  return null;
}

"production" !== process.env.NODE_ENV && (X = function X(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var Z = function Z(e, t) {
  var r = "function" == typeof Symbol && Symbol.iterator;
  var n = {
    array: a("array"),
    bool: a("boolean"),
    func: a("function"),
    number: a("number"),
    object: a("object"),
    string: a("string"),
    symbol: a("symbol"),
    any: s(G),
    arrayOf: function arrayOf(e) {
      return s(function (t, r, n, i, s) {
        if ("function" != typeof e) return new o("Property `" + s + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var a = t[r];
        if (!Array.isArray(a)) return new o("Invalid " + i + " `" + s + "` of type `" + c(a) + "` supplied to `" + n + "`, expected an array.");

        for (var u = 0; u < a.length; u++) {
          var f = e(a, u, n, i, s + "[" + u + "]", U);
          if (f instanceof Error) return f;
        }

        return null;
      });
    },
    element: s(function (t, r, n, i, s) {
      var a = t[r];
      return e(a) ? null : new o("Invalid " + i + " `" + s + "` of type `" + c(a) + "` supplied to `" + n + "`, expected a single ReactElement.");
    }),
    elementType: s(function (e, t, r, n, i) {
      var s = e[t];
      return L.isValidElementType(s) ? null : new o("Invalid " + n + " `" + i + "` of type `" + c(s) + "` supplied to `" + r + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return s(function (t, r, n, i, s) {
        if (!(t[r] instanceof e)) {
          var a = e.name || "<<anonymous>>";
          return new o("Invalid " + i + " `" + s + "` of type `" + function (e) {
            if (!e.constructor || !e.constructor.name) return "<<anonymous>>";
            return e.constructor.name;
          }(t[r]) + "` supplied to `" + n + "`, expected instance of `" + a + "`.");
        }

        return null;
      });
    },
    node: s(function (e, t, r, n, i) {
      return u(e[t]) ? null : new o("Invalid " + n + " `" + i + "` supplied to `" + r + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return s(function (t, r, n, i, s) {
        if ("function" != typeof e) return new o("Property `" + s + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var a = t[r],
            u = c(a);
        if ("object" !== u) return new o("Invalid " + i + " `" + s + "` of type `" + u + "` supplied to `" + n + "`, expected an object.");

        for (var f in a) {
          if (Y(a, f)) {
            var l = e(a, f, n, i, s + "." + f, U);
            if (l instanceof Error) return l;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && (arguments.length > 1 ? X("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : X("Invalid argument supplied to oneOf, expected an array.")), G;

      function t(t, r, n, s, a) {
        for (var u = t[r], c = 0; c < e.length; c++) {
          if (i(u, e[c])) return null;
        }

        var l = JSON.stringify(e, function (e, t) {
          return "symbol" === f(t) ? String(t) : t;
        });
        return new o("Invalid " + s + " `" + a + "` of value `" + String(u) + "` supplied to `" + n + "`, expected one of " + l + ".");
      }

      return s(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && X("Invalid argument supplied to oneOfType, expected an instance of array."), G;

      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        if ("function" != typeof r) return X("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + l(r) + " at index " + t + "."), G;
      }

      return s(function (t, r, n, i, s) {
        for (var a = 0; a < e.length; a++) {
          if (null == (0, e[a])(t, r, n, i, s, U)) return null;
        }

        return new o("Invalid " + i + " `" + s + "` supplied to `" + n + "`.");
      });
    },
    shape: function shape(e) {
      return s(function (t, r, n, i, s) {
        var a = t[r],
            u = c(a);
        if ("object" !== u) return new o("Invalid " + i + " `" + s + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");

        for (var f in e) {
          var l = e[f];

          if (l) {
            var d = l(a, f, n, i, s + "." + f, U);
            if (d) return d;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return s(function (t, r, n, i, s) {
        var a = t[r],
            u = c(a);
        if ("object" !== u) return new o("Invalid " + i + " `" + s + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");
        var f = q({}, t[r], e);

        for (var l in f) {
          var d = e[l];
          if (!d) return new o("Invalid " + i + " `" + s + "` key `" + l + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var p = d(a, l, n, i, s + "." + l, U);
          if (p) return p;
        }

        return null;
      });
    }
  };

  function i(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function o(e) {
    this.message = e, this.stack = "";
  }

  function s(e) {
    if ("production" !== process.env.NODE_ENV) var r = {},
        n = 0;

    function i(i, s, a, u, c, f, l) {
      if (u = u || "<<anonymous>>", f = f || a, l !== U) {
        if (t) {
          var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw d.name = "Invariant Violation", d;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var p = u + ":" + a;
          !r[p] && n < 3 && (X("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + u + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[p] = !0, n++);
        }
      }

      return null == s[a] ? i ? null === s[a] ? new o("The " + c + " `" + f + "` is marked as required in `" + u + "`, but its value is `null`.") : new o("The " + c + " `" + f + "` is marked as required in `" + u + "`, but its value is `undefined`.") : null : e(s, a, u, c, f);
    }

    var s = i.bind(null, !1);
    return s.isRequired = i.bind(null, !0), s;
  }

  function a(e) {
    return s(function (t, r, n, i, s, a) {
      var u = t[r];
      return c(u) !== e ? new o("Invalid " + i + " `" + s + "` of type `" + f(u) + "` supplied to `" + n + "`, expected `" + e + "`.") : null;
    });
  }

  function u(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(u);
        if (null === t || e(t)) return !0;

        var n = function (e) {
          var t = e && (r && e[r] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!n) return !1;
        var i,
            o = n.call(t);

        if (n !== t.entries) {
          for (; !(i = o.next()).done;) {
            if (!u(i.value)) return !1;
          }
        } else for (; !(i = o.next()).done;) {
          var s = i.value;
          if (s && !u(s[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function c(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function f(e) {
    if (null == e) return "" + e;
    var t = c(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function l(e) {
    var t = f(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return o.prototype = Error.prototype, n.checkPropTypes = J, n.resetWarningCache = J.resetWarningCache, n.PropTypes = n, n;
};

function ee() {}

function te() {}

te.resetWarningCache = ee;
var re = r(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = L;
    e.exports = Z(t.isElement, !0);
  } else e.exports = function () {
    function e(e, t, r, n, i, o) {
      if (o !== U) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: te,
      resetWarningCache: ee
    };
    return r.PropTypes = r, r;
  }();
});

function ne(e) {
  if (e < 1048576) {
    var t = (e / 1024).toFixed(0);
    return t <= 0 ? e + " B" : t + " KB";
  }

  return e < 1073741824 ? (e / 1048576).toFixed(0) + " MB" : e < 1099511627776 ? (e / 1073741824).toFixed(0) + " GB" : "";
}

var ie = {
  dropArea: {
    borderWidth: 2,
    borderStyle: "dashed",
    borderColor: "#ccc",
    borderRadius: 20,
    height: "100%",
    padding: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  inputFile: {
    display: "none"
  },
  highlight: {
    borderColor: "purple"
  },
  unhighlight: {
    borderColor: "#ccc"
  },
  dropFile: {
    background: "linear-gradient(to bottom, #eee, #ddd)",
    borderRadius: 20,
    width: 100,
    height: 120,
    position: "relative",
    display: "block",
    zIndex: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
  column: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  progressBar: {
    boxShadow: "inset 0 1px 3px rgba(0, 0, 0, .2)",
    width: "80%",
    borderRadius: 3,
    position: "absolute",
    bottom: 14
  },
  progressBarFill: {
    transition: "width 500ms ease-in-out",
    height: 10,
    backgroundColor: "#659cef",
    borderRadius: 3
  },
  fileSizeInfo: {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    padding: "0 0.4em",
    borderRadius: 3,
    lineHeight: 1,
    marginBottom: "0.5em"
  },
  fileNameInfo: {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    fontSize: 14,
    padding: "0 0.4em",
    borderRadius: 3,
    lineHeight: 1
  },
  defaultCursor: {
    cursor: "default"
  },
  pointerCursor: {
    cursor: "pointer"
  }
},
    oe = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && u(e, t);
  }(g, t.Component);
  var r,
      p,
      h,
      y,
      m = (r = g, function () {
    var e,
        t = a(r);

    if (c()) {
      var n = a(this).constructor;
      e = Reflect.construct(t, arguments, n);
    } else e = t.apply(this, arguments);

    return l(this, e);
  });

  function g() {
    var e;
    i(this, g);

    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
      o[a] = arguments[a];
    }

    return s(f(e = m.call.apply(m, [this].concat(o))), "inputFileRef", t.createRef()), s(f(e), "dropAreaRef", t.createRef()), s(f(e), "fileSizeInfoRef", t.createRef()), s(f(e), "fileNameInfoRef", t.createRef()), s(f(e), "progressBarFillRef", t.createRef()), s(f(e), "state", {
      dropAreaStyle: ie.dropArea,
      hasFiles: !1,
      progressBar: 0,
      displayProgressBarStatus: "none",
      file: "",
      timeout: null
    }), s(f(e), "componentDidMount", function () {
      var t = e.dropAreaRef.current;

      if (["dragenter", "dragover", "dragleave", "drop"].forEach(function (r) {
        t.addEventListener(r, e.preventDefaults, !1);
      }), !e.props.noDrag) {
        ["dragenter", "dragover"].forEach(function (r) {
          t.addEventListener(r, e.highlight, !1);
        }), t.addEventListener("dragleave", e.unhighlight, !1), t.addEventListener("drop", e.unhighlight, !1), t.addEventListener("drop", e.visibleProgressBar, !1), t.addEventListener("drop", e.handleDrop, !1);
      }
    }), s(f(e), "preventDefaults", function (e) {
      e.preventDefault(), e.stopPropagation();
    }), s(f(e), "highlight", function () {
      e.setState({
        dropAreaStyle: Object.assign({}, ie.dropArea, ie.highlight)
      }), e.initializeProgress();
    }), s(f(e), "initializeProgress", function () {
      e.setState({
        progressBar: 0
      });
    }), s(f(e), "unhighlight", function () {
      e.setState({
        dropAreaStyle: Object.assign({}, ie.dropArea, ie.unhighlight)
      });
    }), s(f(e), "visibleProgressBar", function () {
      e.setState({
        displayProgressBarStatus: "block"
      });
    }), s(f(e), "handleDrop", function (t) {
      var r = {};

      if (void 0 === t.files) {
        var n = t.dataTransfer;
        r = n.files;
      } else r = t.files;

      e.setState({
        hasFiles: !0
      }, function () {
        e.handleFiles(r);
      });
    }), s(f(e), "handleFiles", function (t) {
      e.setState({
        progressBar: 0
      }), (t = d(t)).forEach(e.uploadFile);
    }), s(f(e), "uploadFile", function (t, r) {
      e.displayFileInfo(t), e.setState({
        file: t
      });
      var i = e.props,
          o = i.onDrop,
          s = i.onFileLoad,
          a = i.onError,
          u = i.config,
          c = void 0 === u ? {} : u,
          l = new window.FileReader(),
          d = {};
      c.error && delete c.error, c.step && delete c.step, c.complete && delete c.complete;
      var p = t.size,
          h = [],
          y = 0;

      if (o || s) {
        var m = f(e);
        d = Object.assign({
          complete: function complete() {
            o ? o(h) : s(h);
          },
          step: function step(e, t) {
            h.push(e);
            var r = e.meta.cursor,
                n = Math.round(r / p * 100);
            n !== y && (y = n, m.updateProgress(y));
          }
        }, d);
      }

      a && (d = Object.assign({
        error: a
      }, d)), c && (d = Object.assign(c, d)), l.onload = function (e) {
        n.parse(e.target.result, d);
      }, l.onloadend = function (t) {
        clearTimeout(e.state.timeout), e.setState({
          timeout: setTimeout(function () {
            e.disableProgressBar();
          }, 2e3)
        });
      }, l.readAsText(t, c.encoding || "utf-8");
    }), s(f(e), "displayFileInfo", function (t) {
      e.childrenIsFunction() || (e.fileSizeInfoRef.current.innerHTML = ne(t.size), e.fileNameInfoRef.current.innerHTML = t.name);
    }), s(f(e), "updateProgress", function (t) {
      e.setState({
        progressBar: t
      });
    }), s(f(e), "disableProgressBar", function () {
      e.setState({
        displayProgressBarStatus: "none"
      });
    }), s(f(e), "childrenIsFunction", function () {
      return "function" == typeof e.props.children;
    }), s(f(e), "handleInputFileChange", function (t) {
      var r = t.target;
      e.setState({
        displayProgressBarStatus: "block"
      }, function () {
        e.handleDrop(r);
      });
    }), s(f(e), "open", function (t) {
      t && (t.stopPropagation(), e.inputFileRef.current.click());
    }), s(f(e), "renderChildren", function () {
      return e.childrenIsFunction() ? e.props.children({
        file: e.state.file
      }) : e.props.children;
    }), e;
  }

  return p = g, (h = [{
    key: "render",
    value: function value() {
      var e = this,
          r = this.props,
          n = r.style,
          i = r.noClick,
          o = r.children,
          s = r.progressBarColor;
      return t.createElement(t.Fragment, null, t.createElement("input", {
        type: "file",
        accept: "text/csv",
        ref: this.inputFileRef,
        style: ie.inputFile,
        onChange: function onChange(t) {
          return e.handleInputFileChange(t);
        }
      }), this.childrenIsFunction() ? t.createElement("div", {
        ref: this.dropAreaRef
      }, this.renderChildren(), t.createElement("div", {
        style: Object.assign({}, ie.progressBar, {
          position: "inherit",
          width: "100%"
        })
      }, t.createElement("span", {
        style: Object.assign({}, ie.progressBarFill, {
          backgroundColor: s || "#659cef"
        }, {
          width: "".concat(this.state.progressBar, "%"),
          display: this.state.displayProgressBarStatus
        }),
        ref: this.progressBarFillRef
      }))) : t.createElement("div", {
        ref: this.dropAreaRef,
        style: Object.assign({}, n, this.state.dropAreaStyle, i ? ie.defaultCursor : ie.pointerCursor),
        onClick: i ? function () {} : this.open
      }, this.state.hasFiles ? t.createElement("div", {
        style: Object.assign({}, ie.dropFile, ie.column)
      }, t.createElement("div", {
        style: ie.column
      }, t.createElement("span", {
        style: ie.fileSizeInfo,
        ref: this.fileSizeInfoRef
      }), t.createElement("span", {
        style: ie.fileNameInfo,
        ref: this.fileNameInfoRef
      })), t.createElement("div", {
        style: ie.progressBar
      }, t.createElement("span", {
        style: Object.assign({}, ie.progressBarFill, {
          width: "".concat(this.state.progressBar, "%"),
          display: this.state.displayProgressBarStatus
        }),
        ref: this.progressBarFillRef
      }))) : o));
    }
  }]) && o(p.prototype, h), y && o(p, y), g;
}();

function se(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return n.parse(e, t);
}

function ae(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  n.parse(e, Object.assign({}, {
    download: !0
  }, t));
}

function ue(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return n.unparse(e, t);
}

s(oe, "propTypes", {
  children: re.any.isRequired,
  onDrop: re.func,
  onFileLoad: re.func,
  onError: re.func,
  config: re.object,
  style: re.object,
  noClick: re.bool,
  noDrag: re.bool,
  progressBarColor: re.string
});
var ce = n.BAD_DELIMITERS,
    fe = n.RECORD_SEP,
    le = n.UNIT_SEP,
    de = n.WORKERS_SUPPORTED,
    pe = n.LocalChunkSize,
    he = n.DefaultDelimiter;
export { ce as BAD_DELIMITERS, oe as CSVReader, he as DefaultDelimiter, pe as LocalChunkSize, fe as RECORD_SEP, le as UNIT_SEP, de as WORKERS_SUPPORTED, ue as jsonToCSV, ae as readRemoteFile, se as readString };